import AutoReplenishment from 'components/ProductPage/DeliveryOptions/AutoReplenishment/AutoReplenishment';

export default AutoReplenishment;
